import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminAccessGuard } from '../../guards/admin-access.guard';

import { AdminComponent } from './admin.component';
import { AdminAccountComponent } from './account/account.component';
import { AdminAccountCreateComponent } from './account/create/account-create.component';
import { AdminAccountListComponent } from './account/list/account-list.component';
import { AdminAccountEditComponent } from './account/edit/account-edit.component';
import { AdminSettingComponent } from './setting/setting.component';
import { AdminSettingEmailComponent } from './setting/email/email.component';
import { ReportingComponent } from './reporting/reporting.component';

const adminRoutes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminAccessGuard],
    children: [
      {
        path: 'account',
        component: AdminAccountComponent,
        children: [
          {
            path: '',
            component: AdminAccountListComponent
          },
          {
            path: 'create',
            component: AdminAccountCreateComponent
          },
          {
            path: 'edit',
            component: AdminAccountEditComponent
          },
        ]
      },
      {
        path: 'reporting',
        component: ReportingComponent,
      },
      {
        path: 'setting',
        component: AdminSettingComponent,
        children: [
          {
            path: 'email',
            component: AdminSettingEmailComponent
          },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(adminRoutes)
  ],
  exports: [RouterModule]
})

export class AdminRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-routing.module.ts